export default __webpack_public_path__ + "locales/en/Settings.json?hash=c79939d73b8804831a2e566e9ccb4071";